import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../Components/Header";
import BlueButton from "../Components/BlueButton";
import { BRAND } from "../css/brand";
import EntityTable from "../Components/EntityTable";
import { Plus, RefreshCw, Download, XCircle, Factory, Truck, Package, Store, ShoppingCart } from "lucide-react";
import { CREATE_CAP } from "../Data/CREATE_CAP";
import { fetchRoles, getRoleName } from "../Data/ROLES";
import UserForm from "./UserForm";
import { useLocation, useNavigate } from "react-router-dom";
import KpiCard from "../Components/KpiCard";
import Loader from "../Components/Loader";
import GoBackButton from "../Components/GoBackButton";
import RemapButton from "../Components/RemapButton";

export default function Entities({
  overrideRole = null,
  overrideUserId = null,
  overrideRoleId = null,
  // compactView = false,
}) {
  const [role, setRole] = useState("");
  const [rolefromsession, setRolefromsession] = useState("");
  const [userId, setUserId] = useState(null);
  const [rolesLoaded, setRolesLoaded] = useState(false);
  const [data, setData] = useState({});
  const [filter, setFilter] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ loader state added
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");
  const [activeTab, setActiveTab] = useState("CNF");
  const [showAdd, setShowAdd] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);
  const [downloading, setDownloading] = useState(false);
  console.log("overrideUserId: ", overrideUserId)
  console.log("overrideUserId: ", overrideRole)


   useEffect(() => {
      const stored = sessionStorage.getItem("authUserData1");
      if (stored) {
        try {
          const user = JSON.parse(stored);
          if (user?.data?.[0]) {
            setRolefromsession(user.data[0].role);
            setUserId(user.data[0].id);
          }
        } catch (err) {
          console.error("Invalid session data:", err);
        }
      }
    }, []);

  const roleTables = {
    Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
    // CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
    // "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
    // Distributor: ["Micro Distributor", "Retailer"],
    // "Micro Distributor": ["Retailer"],
    CNF: ["Super Stockist"],
    "Super Stockist": ["Distributor"],
    Distributor: ["Micro Distributor", "Retailer"],
    "FOS": ["Retailer"],
    Retailer: [],
  };

  const tabIcons = {
  CNF: <Factory size={18} />,
  "Super Stockist": <Truck size={18} />,
  Distributor: <Package size={18} />,
  "Micro Distributor": <Store size={18} />,
  Retailer: <ShoppingCart size={18} />,
};


  const apiRoleMap = {
    Company: {
      CNF: { role: 3, parentKey: "company_id" },
      "Super Stockist": { role: 4, parentKey: "company_id" },
      Distributor: { role: 5, parentKey: "company_id" },
      "Micro Distributor": { role: 6, parentKey: "company_id" },
      Retailer: { role: 7, parentKey: "company_id" },
    },
    CNF: {
      "Super Stockist": { role: 4, parentKey: "cnf_id" },
      Distributor: { role: 5, parentKey: "cnf_id" },
      "Micro Distributor": { role: 6, parentKey: "cnf_id" },
      Retailer: { role: 7, parentKey: "cnf_id" },
    },
    "Super Stockist": {
      Distributor: { role: 5, parentKey: "ss_id" },
      "Micro Distributor": { role: 6, parentKey: "ss_id" },
      Retailer: { role: 7, parentKey: "ss_id" },
    },
    Distributor: {
      "Micro Distributor": { role: 6, parentKey: "dist_id" },
      Retailer: { role: 7, parentKey: "dist_id" },
    },
    "FOS": { Retailer: { role: 7, parentKey: "fos_id" } },
  };

  // 🔹 Load roles
  useEffect(() => {
    async function loadRoles() {
      await fetchRoles();
      setRolesLoaded(true);
    }
    loadRoles();
  }, []);

  // 🔹 Get user info or override
  useEffect(() => {
    const stored = sessionStorage.getItem("authUserData1");

    if (overrideRole && overrideUserId) {
      setRole(getRoleName(overrideRole));
      setRolefromsession(overrideRole);
      setUserId(overrideUserId);
    } else if (overrideRoleId && overrideUserId) {
      setRole(getRoleName(overrideRoleId));
      setRolefromsession(overrideRoleId);
      setUserId(overrideUserId);
    } else if (stored) {
      try {
        const user = JSON.parse(stored);
        const loginRoleId = user?.data[0]?.role;
        setRole(getRoleName(loginRoleId));
        setRolefromsession(loginRoleId)
        setUserId(user?.data[0]?.id);
      } catch (err) {
        console.error(err);
      }
    }
  }, [rolesLoaded, overrideRole, overrideUserId, overrideRoleId]);

  // ✅ Load correct tab
  useEffect(() => {
    if (!role || !userId) return;
    const validTabs = roleTables[role] || [];
    let initialTab =
      tabParam && validTabs.includes(tabParam) ? tabParam : validTabs[0] || "CNF";
    setActiveTab(initialTab);
    fetchEntities(initialTab);
  }, [role, userId]);

  // ✅ Handle manual URL tab change
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = params.get("tab");
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
      fetchEntities(tabFromUrl);
    }
  }, [location.search]);

  // ✅ Fetch entities with loader
  const fetchEntities = async (entityType, page = 1) => {
    if (!role || !userId) return;
    const map = apiRoleMap[role]?.[entityType];
    if (!map) return;
    setLoading(true); // ✅ Start loader
    try {
      const res = await axios.get("https://spillas.com/api/v1/org_user", {
        params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
      });
      setData((prev) => ({
        ...prev,
        [entityType]: {
          rows: res.data.data || [],
          meta: {
            current_page: res.data.current_page,
            last_page: res.data.last_page,
          },
        },
      }));
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch data", "error");
    } finally {
      setLoading(false); // ✅ Stop loader
    }
  };

  const handleSearch = async (value) => {
    setFilter(value);
    if (!value.trim()) {
      setIsSearching(false);
      fetchEntities(activeTab);
      return;
    }
    const map = apiRoleMap[role]?.[activeTab];
    if (!map) return;
    setIsSearching(true);
    try {
      const prefixMap = {
        CNF: "CNF",
        "Super Stockist": "SS",
        Distributor: "DIST",
        "Micro Distributor": "MD",
        Retailer: "RTL",
      };
      const orgPrefix = prefixMap[activeTab] || "";
      const roleId = map.role;
      const params = { [map.parentKey]: userId, login_id: userId, role: roleId };
      if (value.toUpperCase().startsWith(orgPrefix)) {
        params.org_code = value.toUpperCase();
      } else if (value.length >= 3) {
        params.business_name = value;
      } else {
        setIsSearching(false);
        return;
      }
      const res = await axios.get("https://spillas.com/api/v1/org_user/search", { params });
      const results = Array.isArray(res.data) ? res.data : [];
      setData((prev) => ({
        ...prev,
        [activeTab]: { rows: results, meta: null },
      }));
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
    }
  };

  const handleReset = () => {
    setFilter("");
    setIsSearching(false);
    fetchEntities(activeTab);
  };

  const handleRefresh = () => {
    fetchEntities(activeTab);
    Swal.fire({
      icon: "success",
      title: "Data Refreshed",
      timer: 1000,
      showConfirmButton: false,
    });
  };

  const handleDownload = async () => {
    const map = apiRoleMap[role]?.[activeTab];
    if (!map) return;

    try {
      setDownloading(true); // ✅ Show downloading state

      const res = await axios.get("https://spillas.com/api/v1/org_user", {
        params: {
          role: map.role,
          [map.parentKey]: userId,
          page: 1,
          per_page: 10000,
        },
      });

      const rows = res.data?.data || [];
      if (!rows.length) {
        Swal.fire("No data to download", "", "info");
        return;
      }

      // ✅ Define the exact fields and headers you want in the CSV
      const selectedFields = [
        "id",
        "org_code",
        "business_name",
        "role",
        "mobile",
        "email",
        "state",
        "district",
        "taluka",
        "pincode",
        "gst",
        "pan",
        "owner_name",
        "company_name",
        "cnf_name",
        "ss_name",
        "dist_name",
        "fos_name",
        "is_active",
        "created_at",
      ];

      // ✅ Create CSV content
      const csvRows = [
        selectedFields.join(","), // headers
        ...rows.map((r) =>
          selectedFields.map((key) => `"${r[key] ?? ""}"`).join(",")
        ),
      ];

      // ✅ Generate and download the CSV file
      const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${activeTab}_data.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Download failed:", err);
      Swal.fire("Failed to download data", "", "error");
    } finally {
      setDownloading(false); // ✅ Hide downloading state
    }
  };

  const handlePageChange = (entityType, page) => fetchEntities(entityType, page);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setFilter("");
    fetchEntities(tab);
    navigate(`?tab=${encodeURIComponent(tab)}`);
  };

  const handleToggle = async (type, id, currentStatus) => {
    const action = currentStatus === 1 ? "Deactivate" : "Activate";
    const confirm = await Swal.fire({
      title: `Are you sure?`,
      text: `You are about to ${action.toLowerCase()} this ${type}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, ${action}`,
    });
    if (!confirm.isConfirmed) return;
    try {
      setUpdatingId(id);
      const res = await axios.post(`https://spillas.com/api/v1/org_user/status/${id}`);
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Status Updated",
          timer: 1500,
          showConfirmButton: false,
        });
        fetchEntities(type);
      }
    } catch (err) {
      console.error("Error updating status:", err);
      Swal.fire("Failed", `Could not ${action.toLowerCase()} this ${type}`, "error");
    } finally {
      setUpdatingId(null);
    }
  };

  const canCreate = CREATE_CAP[role] || [];

  const remapEntity = (type, id, newParent) => {
    setData((d) => {
      const upd = (arr) => arr.map((x) => (x.id === id ? { ...x, parent: newParent } : x));
      if (type === "Super Stockist") return { ...d, sstks: upd(d.sstks) };
      if (type === "Distributor") return { ...d, dists: upd(d.dists) };
      if (type === "Micro Distributor") return { ...d, mdists: upd(d.mdists) };
      if (type === "Retailer") return { ...d, rets: upd(d.rets) };
      return d;
    });
  };

  return (
    <div className="">
     <GoBackButton/>
        <Header brand={BRAND} title="Manage Network"/>
         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
            {/* KPI Section */}
            <div className="flex flex-wrap gap-3 w-full sm:w-auto">
              <KpiCard
                mode="entities"
                title={activeTab}
                userId={userId}
                role={rolefromsession}
              />
            </div>

            {/* Controls Section */}
            <div className="flex flex-wrap gap-2 sm:w-auto">
              <input
                value={filter}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Search by code or name"
                className="w-24 sm:w-32 md:w-40 lg:w-48 rounded-lg border px-2 py-1 text-sm"
              />

              <BlueButton brand={BRAND} onClick={handleReset} className="inline-flex items-center gap-1">
                <XCircle size={14} />
                <span className="hidden sm:inline">Reset</span>
              </BlueButton>

              <BlueButton brand={BRAND} onClick={handleRefresh} className="inline-flex items-center gap-1">
                <RefreshCw size={14} />
                <span className="hidden sm:inline">Refresh</span>
              </BlueButton>

              <BlueButton
                brand={BRAND}
                onClick={handleDownload}
                disabled={downloading}
                className="inline-flex items-center gap-1"
              >
                {downloading ? (
                  <>
                    <Download size={14} />
                    <span className="hidden sm:inline">Downloading...</span>
                  </>
                ) : (
                  <>
                    <Download size={14} />
                    <span className="hidden sm:inline">Download</span>
                  </>
                )}
              </BlueButton>


              {canCreate.length > 0 && (
                <BlueButton
                  brand={BRAND}
                  onClick={() => setShowAdd(true)}
                  className="inline-flex items-center gap-1"
                >
                  <Plus size={14} />
                  <span className="hidden sm:inline">Register Now</span>
                </BlueButton>
              )}

               {role === "Company" && <RemapButton data={data} onRemap={remapEntity} />} 
            </div>
          </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-200 mt-3 overflow-x-auto">
        {roleTables[role]?.map((tab) => (
          <button
            key={tab}
            className={`flex items-center justify-center gap-2 px-4 py-2 font-semibold transition-all whitespace-nowrap ${
              activeTab === tab
                ? "border-b-2 border-blue-600 text-blue-600"
                : "text-gray-600 hover:text-blue-600"
            }`}
            onClick={() => handleTabClick(tab)}
          >
            {/* Show icon on mobile, text on larger screens */}
            <span className="sm:hidden">{tabIcons[tab]}</span>
            <span className="hidden sm:inline">{tab}</span>
          </button>
        ))}
      </div>

      {/* ✅ Loader or Table */}
      <div className="mt-3 min-h-[250px] items-center overflow-x-auto">
        {loading ? (
          <Loader text="Loading Users..." />
        ) : isSearching ? (
          <div className="flex flex-col items-center text-gray-600">
            <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
            <p>Searching users...</p>
          </div>
        ) : data[activeTab]?.rows?.length === 0 ? (
          <div className="text-gray-500 text-center py-6">No user found</div>
        ) : (
          <EntityTable
            rows={data[activeTab]?.rows || []}
            type={activeTab}
            meta={data[activeTab]?.meta}
            onPageChange={(page) => handlePageChange(activeTab, page)}
            onToggle={(type, id, status) => handleToggle(type, id, status)}
          />
        )}
      </div>

      {/* Modal */}
      {showAdd && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20 backdrop-blur-sm">
          <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
              <button onClick={() => setShowAdd(false)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
            <UserForm onCancel={() => setShowAdd(false)} onSubmit={() => setShowAdd(false)} />
          </div>
        </div>
      )}
    </div>
  );
}


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import EntityTable from "../Components/EntityTable";
// import { Plus, RefreshCw, Download, XCircle } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function Entities({
//   overrideRole = null,
//   overrideUserId = null,
//   overrideRoleId = null,
//   compactView = false,
// }) {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState("CNF");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);

//   // ---- Role hierarchy ----
//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // ---- Role mapping for APIs ----
//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Load roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info or use override props
// useEffect(() => {
// const stored = sessionStorage.getItem("authUserData1");

// if (overrideRole && overrideUserId) {
//   setRole(overrideRole);
//   setUserId(overrideUserId);
// } else if (overrideRoleId && overrideUserId) {
//   // ✅ Convert numeric ID to role name using getRoleName
//   setRole(getRoleName(overrideRoleId));
//   setUserId(overrideUserId);
// } else if (stored) {
//   try {
//     const user = JSON.parse(stored);
//     const loginRoleId = user?.data[0]?.role;
//     setRole(getRoleName(loginRoleId));
//     setUserId(user?.data[0]?.id);
//   } catch (err) {
//     console.error(err);
//   }
// }
// }, [rolesLoaded, overrideRole, overrideUserId, overrideRoleId]);


//   // ✅ Load correct tab from URL once role + userId available
//   useEffect(() => {
//     if (!role || !userId) return;
//     const validTabs = roleTables[role] || [];
//     let initialTab =
//       tabParam && validTabs.includes(tabParam)
//         ? tabParam
//         : validTabs[0] || "CNF";
//     setActiveTab(initialTab);
//     fetchEntities(initialTab);
//   }, [role, userId]);

//   // ✅ Update tab if URL changes manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   // ✅ Fetch entities API
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;
//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });
//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: {
//             current_page: res.data.current_page,
//             last_page: res.data.last_page,
//           },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ✅ SEARCH API
//   const handleSearch = async (value) => {
//     setFilter(value);
//     if (!value.trim()) {
//       setIsSearching(false);
//       fetchEntities(activeTab);
//       return;
//     }
//     const map = apiRoleMap[role]?.[activeTab];
//     if (!map) return;
//     setIsSearching(true);
//     try {
//       const prefixMap = {
//         CNF: "CNF",
//         "Super Stockist": "SS",
//         Distributor: "DIST",
//         "Micro Distributor": "MD",
//         Retailer: "RTL",
//       };
//       const orgPrefix = prefixMap[activeTab] || "";
//       const roleId = map.role;
//       const params = { [map.parentKey]: userId, login_id: userId, role: roleId };
//       if (value.toUpperCase().startsWith(orgPrefix)) {
//         params.org_code = value.toUpperCase();
//       } else if (value.length >= 3) {
//         params.business_name = value;
//       } else {
//         setIsSearching(false);
//         return;
//       }
//       const res = await axios.get("https://spillas.com/api/v1/org_user/search", {
//         params,
//       });
//       const results = Array.isArray(res.data) ? res.data : [];
//       setData((prev) => ({
//         ...prev,
//         [activeTab]: { rows: results, meta: null },
//       }));
//     } catch (err) {
//       console.error("Search failed:", err);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const handleReset = () => {
//     setFilter("");
//     setIsSearching(false);
//     fetchEntities(activeTab);
//   };

//   const handleRefresh = () => {
//     fetchEntities(activeTab);
//     Swal.fire({
//       icon: "success",
//       title: "Data Refreshed",
//       timer: 1000,
//       showConfirmButton: false,
//     });
//   };

//   const handleDownload = async () => {
//     const map = apiRoleMap[role]?.[activeTab];
//     if (!map) return;
//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: {
//           role: map.role,
//           [map.parentKey]: userId,
//           page: 1,
//           per_page: 10000,
//         },
//       });
//       const rows = res.data?.data || [];
//       if (!rows.length) {
//         Swal.fire("No data to download", "", "info");
//         return;
//       }
//       const headers = Object.keys(rows[0]);
//       const cutoffIndex = headers.indexOf("created_at");
//       const limitedHeaders =
//         cutoffIndex !== -1 ? headers.slice(0, cutoffIndex + 1) : headers;
//       const csvRows = [
//         limitedHeaders.join(","),
//         ...rows.map((r) =>
//           limitedHeaders.map((key) => `"${r[key] ?? ""}"`).join(",")
//         ),
//       ];
//       const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${activeTab}_data.csv`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (err) {
//       console.error("Download failed:", err);
//       Swal.fire("Failed to download data", "", "error");
//     }
//   };

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setFilter("");
//     fetchEntities(tab);
//     if (!compactView) navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";
//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });
//     if (!confirm.isConfirmed) return;
//     try {
//       setUpdatingId(id);
//       const res = await axios.post(`https://spillas.com/api/v1/org_user/status/${id}`);
//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const canCreate = CREATE_CAP[role] || [];

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       {!compactView && (
//         <Header brand={BRAND} title="Manage Network">
//           <div className="flex flex-wrap items-center gap-2">
//             <input
//               value={filter}
//               onChange={(e) => handleSearch(e.target.value)}
//               placeholder="Search by code or name"
//               className="rounded-lg border px-2 py-1 text-sm"
//             />

//             <BlueButton brand={BRAND} onClick={handleReset} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//               <XCircle size={14} />
//               <span className="hidden sm:inline">Reset</span>
//             </BlueButton>

//             <BlueButton brand={BRAND} onClick={handleRefresh} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//               <RefreshCw size={14} />
//               <span className="hidden sm:inline">Refresh</span>
//             </BlueButton>

//             <BlueButton brand={BRAND} onClick={handleDownload} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//               <Download size={14} />
//               <span className="hidden sm:inline">Download</span>
//             </BlueButton>

//             {canCreate.length > 0 && (
//               <BlueButton brand={BRAND} onClick={() => setShowAdd(true)} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//                 <Plus size={14} />
//                 <span className="hidden sm:inline">Register Now</span>
//               </BlueButton>
//             )}
//           </div>
//         </Header>
//       )}

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3 min-h-[200px] w-full flex justify-center">
//         <div className="w-full">
//           {isSearching ? (
//             <div className="flex flex-col items-center text-gray-600">
//               <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
//               <p>Searching users...</p>
//             </div>
//           ) : data[activeTab]?.rows?.length === 0 ? (
//             <div className="text-gray-500 text-center py-6">No user found</div>
//           ) : (
//             <EntityTable
//               rows={data[activeTab]?.rows || []}
//               type={activeTab}
//               meta={data[activeTab]?.meta}
//               onPageChange={(page) => handlePageChange(activeTab, page)}
//               onToggle={(type, id, status) => handleToggle(type, id, status)}
//             />
//           )}
//         </div>
//       </div>

//       {/* Add User Modal */}
//       {!compactView && showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
//               <button
//                 onClick={() => setShowAdd(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 ✕
//               </button>
//             </div>
//             <UserForm
//               onCancel={() => setShowAdd(false)}
//               onSubmit={() => setShowAdd(false)}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import EntityTable from "../Components/EntityTable";
// import { Plus, RotateCw, RefreshCw, Download, XCircle } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";
// // import RemapButton from "../Components/RemapButton";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState("CNF");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);


  // const remapEntity = (type, id, newParent) => {
  //   setData((d) => {
  //     const upd = (arr) => arr.map((x) => (x.id === id ? { ...x, parent: newParent } : x));
  //     if (type === "Super Stockist") return { ...d, sstks: upd(d.sstks) };
  //     if (type === "Distributor") return { ...d, dists: upd(d.dists) };
  //     if (type === "Micro Distributor") return { ...d, mdists: upd(d.mdists) };
  //     if (type === "Retailer") return { ...d, rets: upd(d.rets) };
  //     return d;
  //   });
  // };

//   // ---- Role hierarchy ----
//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // ---- Role mapping for APIs ----
//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Load roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   // ✅ Load correct tab from URL once role + userId available
//   useEffect(() => {
//     if (!role || !userId) return;

//     const validTabs = roleTables[role] || [];
//     let initialTab =
//       tabParam && validTabs.includes(tabParam)
//         ? tabParam
//         : validTabs[0] || "CNF";

//     setActiveTab(initialTab);
//     fetchEntities(initialTab);
//   }, [role, userId]);

//   // ✅ Update tab if URL changes manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   // ✅ Fetch entities API
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: {
//             current_page: res.data.current_page,
//             last_page: res.data.last_page,
//           },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ✅ SEARCH API
//   const handleSearch = async (value) => {
//     setFilter(value);
//     if (!value.trim()) {
//       setIsSearching(false);
//       fetchEntities(activeTab);
//       return;
//     }

//     const map = apiRoleMap[role]?.[activeTab];
//     if (!map) return;

//     setIsSearching(true);
//     try {
//       const prefixMap = {
//         CNF: "CNF",
//         "Super Stockist": "SS",
//         Distributor: "DIST",
//         "Micro Distributor": "MD",
//         Retailer: "RTL",
//       };
//       const orgPrefix = prefixMap[activeTab] || "";
//       const roleId = map.role;

//       const params = {
//         [map.parentKey]: userId,
//         login_id: userId,
//         role: roleId,
//       };

//       if (value.toUpperCase().startsWith(orgPrefix)) {
//         params.org_code = value.toUpperCase();
//       } else if (value.length >= 3) {
//         params.business_name = value;
//       } else {
//         setIsSearching(false);
//         return;
//       }

//       const res = await axios.get("https://spillas.com/api/v1/org_user/search", {
//         params,
//       });

//       const results = Array.isArray(res.data) ? res.data : [];

//       setData((prev) => ({
//         ...prev,
//         [activeTab]: { rows: results, meta: null },
//       }));
//     } catch (err) {
//       console.error("Search failed:", err);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   // ✅ Reset Filters
//   const handleReset = () => {
//     setFilter("");
//     setIsSearching(false);
//     fetchEntities(activeTab);
//   };

//   // ✅ Refresh Latest Data
//   const handleRefresh = () => {
//     fetchEntities(activeTab);
//     Swal.fire({
//       icon: "success",
//       title: "Data Refreshed",
//       timer: 1000,
//       showConfirmButton: false,
//     });
//   };

//   // ✅ Download Current Table (limit columns till created_at)
//   // ✅ Download Current Table (limit columns till created_at)
// const handleDownload = async () => {
//   const map = apiRoleMap[role]?.[activeTab];
//   if (!map) return;

//   try {
//     // 🔹 Fetch up to 10,000 records for the download
//     const res = await axios.get("https://spillas.com/api/v1/org_user", {
//       params: {
//         role: map.role,
//         [map.parentKey]: userId,
//         page: 1,
//         per_page: 10000,
//       },
//     });

//     const rows = res.data?.data || [];
//     if (!rows.length) {
//       Swal.fire("No data to download", "", "info");
//       return;
//     }

//     // 🔹 Limit columns till created_at
//     const headers = Object.keys(rows[0]);
//     const cutoffIndex = headers.indexOf("created_at");
//     const limitedHeaders =
//       cutoffIndex !== -1 ? headers.slice(0, cutoffIndex + 1) : headers;

//     const csvRows = [
//       limitedHeaders.join(","), // headers
//       ...rows.map((r) =>
//         limitedHeaders.map((key) => `"${r[key] ?? ""}"`).join(",")
//       ),
//     ];

//     const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = `${activeTab}_data.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   } catch (err) {
//     console.error("Download failed:", err);
//     Swal.fire("Failed to download data", "", "error");
//   }
// };

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setFilter("");
//     fetchEntities(tab);
//     navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";
//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setUpdatingId(id);
//       const res = await axios.post(`https://spillas.com/api/v1/org_user/status/${id}`);
//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const canCreate = CREATE_CAP[role] || [];

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => handleSearch(e.target.value)}
//             placeholder="Search by code or name"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           <BlueButton brand={BRAND} onClick={handleReset}  className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//             <XCircle size={14} />
//             <span className="hidden sm:inline">Reset</span>
//           </BlueButton>

//           <BlueButton brand={BRAND} onClick={handleRefresh} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//             <RefreshCw size={14} />
//             <span className="hidden sm:inline">Refresh</span>
//           </BlueButton>

//           <BlueButton brand={BRAND} onClick={handleDownload} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//             <Download size={14} />
//             <span className="hidden sm:inline">Download</span>
//           </BlueButton>

//           {canCreate.length > 0 && (
//             <BlueButton brand={BRAND} onClick={() => setShowAdd(true)} className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap">
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
          // {role === "Company" && <RemapButton data={data} onRemap={remapEntity} />} 
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3 min-h-[200px] w-full flex justify-center">
//         <div className="w-full">
//           {isSearching ? (
//             <div className="flex flex-col items-center text-gray-600">
//               <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
//               <p>Searching users...</p>
//             </div>
//           ) : data[activeTab]?.rows?.length === 0 ? (
//             <div className="text-gray-500 text-center py-6">No user found</div>
//           ) : (
//             <EntityTable
//               rows={data[activeTab]?.rows || []}
//               type={activeTab}
//               meta={data[activeTab]?.meta}
//               onPageChange={(page) => handlePageChange(activeTab, page)}
//               onToggle={(type, id, status) => handleToggle(type, id, status)}
//             />
//           )}
//         </div>
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
//               <button onClick={() => setShowAdd(false)} className="text-gray-500 hover:text-gray-700">✕</button>
//             </div>
//             <UserForm onCancel={() => setShowAdd(false)} onSubmit={() => setShowAdd(false)} />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState("CNF");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);

//   // ---- Role hierarchy ----
//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // ---- Role mapping for APIs ----
//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Load roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   // ✅ Load correct tab from URL once role + userId available
//   useEffect(() => {
//     if (!role || !userId) return;

//     const validTabs = roleTables[role] || [];
//     let initialTab =
//       tabParam && validTabs.includes(tabParam)
//         ? tabParam
//         : validTabs[0] || "CNF";

//     setActiveTab(initialTab);
//     fetchEntities(initialTab);
//   }, [role, userId]);

//   // ✅ Update tab if URL changes manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   // ✅ Fetch entities API
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: {
//             current_page: res.data.current_page,
//             last_page: res.data.last_page,
//           },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ✅ SEARCH API
//   // ✅ SEARCH API (Updated logic)
//   const handleSearch = async (value) => {
//   setFilter(value);
//   if (!value.trim()) {
//     setIsSearching(false);
//     fetchEntities(activeTab);
//     return;
//   }

//   const map = apiRoleMap[role]?.[activeTab];
//   if (!map) return;

//   setIsSearching(true);
//   try {
//     const prefixMap = {
//       CNF: "CNF",
//       "Super Stockist": "SS",
//       Distributor: "DIST",
//       "Micro Distributor": "MD",
//       Retailer: "RTL",
//     };
//     const orgPrefix = prefixMap[activeTab] || "";
//     const roleId = map.role;

//     const params = {
//       [map.parentKey]: userId,
//       login_id: userId,
//       role: roleId,
//     };

//     // ✅ If input starts with prefix, search by org_code
//     if (value.toUpperCase().startsWith(orgPrefix)) {
//       params.org_code = value.toUpperCase();
//     }
//     // ✅ If input length ≥ 3, search by business name
//     else if (value.length >= 3) {
//       params.business_name = value;
//     } else {
//       setIsSearching(false);
//       return;
//     }

//     const res = await axios.get("https://spillas.com/api/v1/org_user/search", {
//       params,
//     });

//     const results =
//       Array.isArray(res.data) && res.data.length
//         ? res.data
//         : [];

//     setData((prev) => ({
//       ...prev,
//       [activeTab]: { rows: results, meta: null },
//     }));
//   } catch (err) {
//     console.error("Search failed:", err);
//     setData((prev) => ({
//       ...prev,
//       [activeTab]: { rows: [], meta: null },
//     }));
//   } finally {
//     setIsSearching(false);
//   }
// };



//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   // ✅ Handle tab click (update both tab + URL)
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setFilter("");
//     fetchEntities(tab);
//     navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   // ✅ Status toggle
//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";

//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setUpdatingId(id);
//       const res = await axios.post(
//         `https://spillas.com/api/v1/org_user/status/${id}`
//       );

//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const canCreate = CREATE_CAP[role] || [];

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => handleSearch(e.target.value)}
//             placeholder="Search by code or name"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <div className="mt-3 min-h-[200px] w-full flex justify-center">
//               <div className="w-full">
//             {isSearching ? (
//               // 🔹 Loader while searching
//               <div className="flex flex-col items-center text-gray-600">
//                 <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-2"></div>
//                 <p>Searching users...</p>
//               </div>
//             ) : data[activeTab]?.rows?.length === 0 ? (
//               // 🔹 If search result empty or API failed
//               <div className="text-gray-500 text-center py-6">No user found</div>
//             ) : (
//               // 🔹 Show normal table
//               <EntityTable
//                 // title={activeTab}
//                 rows={data[activeTab]?.rows || []}
//                 type={activeTab}
//                 meta={data[activeTab]?.meta}
//                 onPageChange={(page) => handlePageChange(activeTab, page)}
//                 onToggle={(type, id, status) => handleToggle(type, id, status)}
//               />
//             )}
//             </div>
//           </div>

//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">
//                 Add User
//               </h3>
//               <button
//                 onClick={() => setShowAdd(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 ✕
//               </button>
//             </div>
//             <UserForm
//               onCancel={() => setShowAdd(false)}
//               onSubmit={() => setShowAdd(false)}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState("CNF");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);

//   // ---- Role hierarchy ----
//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // ---- Role mapping for APIs ----
//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Load roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   // ✅ Load correct tab from URL once role + userId available
//   useEffect(() => {
//     if (!role || !userId) return;

//     const validTabs = roleTables[role] || [];
//     let initialTab =
//       tabParam && validTabs.includes(tabParam)
//         ? tabParam
//         : validTabs[0] || "CNF";

//     setActiveTab(initialTab);
//     fetchEntities(initialTab);
//   }, [role, userId]);

//   // ✅ Update tab if URL changes manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   // ✅ Fetch entities API
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: {
//             current_page: res.data.current_page,
//             last_page: res.data.last_page,
//           },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ✅ SEARCH API
//   // ✅ SEARCH API (Updated logic)
//   const handleSearch = async (value) => {
//     setFilter(value);
//     if (!value.trim()) {
//       setIsSearching(false);
//       fetchEntities(activeTab);
//       return;
//     }

//     const map = apiRoleMap[role]?.[activeTab];
//     if (!map) return;

//     setIsSearching(true);
//     try {
//       const prefixMap = {
//         CNF: "CNF",
//         "Super Stockist": "SS",
//         Distributor: "DIST",
//         "Micro Distributor": "MD",
//         Retailer: "RTL",
//       };
//       const orgPrefix = prefixMap[activeTab] || "";
//       const roleId = map.role;

//       const params = {
//         [map.parentKey]: userId,
//         login_id: userId,
//         role: roleId,
//       };

//       // ✅ If input starts with the entity prefix (e.g. "CNF"), search by org_code
//       if (value.toUpperCase().startsWith(orgPrefix)) {
//         params.org_code = value.toUpperCase();
//       }
//       // ✅ If input length ≥ 4, search by business_name
//       else if (value.length >= 4) {
//         params.business_name = value;
//       } else {
//         // If too short and not a prefix, don't trigger search
//         setIsSearching(false);
//         return;
//       }

//       const res = await axios.get("https://spillas.com/api/v1/org_user/search", {
//         params,
//       });

//       setData((prev) => ({
//         ...prev,
//         [activeTab]: { rows: res.data || [], meta: null },
//       }));
//     } catch (err) {
//       console.error("Search failed:", err);
//     }
//   };


//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   // ✅ Handle tab click (update both tab + URL)
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setFilter("");
//     fetchEntities(tab);
//     navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   // ✅ Status toggle
//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";

//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setUpdatingId(id);
//       const res = await axios.post(
//         `https://spillas.com/api/v1/org_user/status/${id}`
//       );

//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const canCreate = CREATE_CAP[role] || [];

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => handleSearch(e.target.value)}
//             placeholder="Search by code or name"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <EntityTable
//             title={activeTab}
//             rows={data[activeTab]?.rows || []}
//             type={activeTab}
//             meta={data[activeTab]?.meta}
//             onPageChange={(page) => handlePageChange(activeTab, page)}
//             onToggle={(type, id, status) =>
//               handleToggle(type, id, status)
//             }
//           />
//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">
//                 Add User
//               </h3>
//               <button
//                 onClick={() => setShowAdd(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 ✕
//               </button>
//             </div>
//             <UserForm
//               onCancel={() => setShowAdd(false)}
//               onSubmit={() => setShowAdd(false)}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const location = useLocation();
//   const navigate = useNavigate();
//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState("CNF");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);

//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Fetch roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   // ✅ Load correct tab from URL once role + userId available
//   useEffect(() => {
//     if (!role || !userId) return;

//     const validTabs = roleTables[role] || [];
//     let initialTab =
//       tabParam && validTabs.includes(tabParam)
//         ? tabParam
//         : validTabs[0] || "CNF";

//     setActiveTab(initialTab);
//     fetchEntities(initialTab);
//   }, [role, userId]);

//   // ✅ Update tab if URL changes manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   // ✅ Fetch data
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: {
//             current_page: res.data.current_page,
//             last_page: res.data.last_page,
//           },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   // ✅ Handle tab click (update both tab + URL)
//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     fetchEntities(tab);
//     navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   // ✅ Status toggle
//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";

//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setUpdatingId(id);
//       const res = await axios.post(
//         `https://spillas.com/api/v1/org_user/status/${id}`
//       );

//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const canCreate = CREATE_CAP[role] || [];

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             placeholder="Search by id/name/state/district"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <EntityTable
//             title={activeTab}
//             rows={data[activeTab]?.rows || []}
//             type={activeTab}
//             meta={data[activeTab]?.meta}
//             onPageChange={(page) => handlePageChange(activeTab, page)}
//             onToggle={(type, id, status) =>
//               handleToggle(type, id, status)
//             }
//           />
//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">
//                 Add User
//               </h3>
//               <button
//                 onClick={() => setShowAdd(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 ✕
//               </button>
//             </div>
//             <UserForm
//               onCancel={() => setShowAdd(false)}
//               onSubmit={() => setShowAdd(false)}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";
// import { useLocation, useNavigate } from "react-router-dom";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [showAdd, setShowAdd] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const params = new URLSearchParams(location.search);
//   const tabParam = params.get("tab");
//   const [activeTab, setActiveTab] = useState(tabParam || "CNF");

//   // 🔹 Fetch roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   const canCreate = CREATE_CAP[role] || [];

//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: {
//       "Micro Distributor": { role: 6, parentKey: "dist_id" },
//       Retailer: { role: 7, parentKey: "dist_id" },
//     },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Fetch data
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: { current_page: res.data.current_page, last_page: res.data.last_page },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // ✅ Sync tab with role + URL
//   useEffect(() => {
//     if (!role || !userId) return;

//     const validTabs = roleTables[role] || [];
//     let initialTab = "CNF";

//     if (tabParam && validTabs.includes(tabParam)) {
//       initialTab = tabParam;
//     } else if (validTabs.length > 0) {
//       initialTab = validTabs[0];
//     }

//     if (activeTab !== initialTab) {
//       setActiveTab(initialTab);
//       fetchEntities(initialTab);
//     }
//   }, [role, userId, tabParam]);

//   // ✅ Update if user changes query param manually
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tabFromUrl = params.get("tab");
//     if (tabFromUrl && tabFromUrl !== activeTab) {
//       setActiveTab(tabFromUrl);
//       fetchEntities(tabFromUrl);
//     }
//   }, [location.search]);

//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     fetchEntities(tab);
//     navigate(`?tab=${encodeURIComponent(tab)}`);
//   };

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   // ✅ Status toggle API integration
//   const handleToggle = async (type, id, currentStatus) => {
//     const action = currentStatus === 1 ? "Deactivate" : "Activate";

//     const confirm = await Swal.fire({
//       title: `Are you sure?`,
//       text: `You are about to ${action.toLowerCase()} this ${type}.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//       cancelButtonColor: "#6c757d",
//       confirmButtonText: `Yes, ${action}`,
//     });

//     if (!confirm.isConfirmed) return;

//     try {
//       setUpdatingId(id);
//       const res = await axios.post(`https://spillas.com/api/v1/org_user/status/${id}`);

//       if (res.status === 200) {
//         Swal.fire({
//           icon: "success",
//           title: "Status Updated",
//           text: `${type} has been ${action.toLowerCase()}d successfully.`,
//           timer: 1500,
//           showConfirmButton: false,
//         });
//         fetchEntities(type);
//       }
//     } catch (err) {
//       console.error("Error updating status:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: `Could not ${action.toLowerCase()} this ${type}.`,
//       });
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             placeholder="Search by id/name/state/district"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => handleTabClick(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <EntityTable
//             title={activeTab}
//             rows={data[activeTab]?.rows || []}
//             type={activeTab}
//             meta={data[activeTab]?.meta}
//             onPageChange={(page) => handlePageChange(activeTab, page)}
//             onToggle={(type, id, currentStatus) => handleToggle(type, id, currentStatus)}
//           />
//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
//               <button onClick={() => setShowAdd(false)} className="text-gray-500 hover:text-gray-700">
//                 ✕
//               </button>
//             </div>

//             <UserForm onCancel={() => setShowAdd(false)} onSubmit={() => setShowAdd(false)} />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName } from "../Data/ROLES";
// import UserForm from "./UserForm";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [activeTab, setActiveTab] = useState("");
//   const [showAdd, setShowAdd] = useState(false);

//   // ✅ For button loading state (optional)
//   const [updatingId, setUpdatingId] = useState(null);

//   // 🔹 Fetch roles
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get user info
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]);

//   const canCreate = CREATE_CAP[role] || [];

//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: { "Micro Distributor": { role: 6, parentKey: "dist_id" }, Retailer: { role: 7, parentKey: "dist_id" } },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Fetch data
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: { current_page: res.data.current_page, last_page: res.data.last_page },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     if (role) {
//       const firstTab = roleTables[role]?.[0];
//       setActiveTab(firstTab);
//       if (firstTab) fetchEntities(firstTab);
//     }
//   }, [role, userId]);

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

//   // ✅ Status toggle API integration
//   const handleToggle = async (type, id, currentStatus) => {
//   const action = currentStatus === 1 ? "Deactivate" : "Activate";

//   const confirm = await Swal.fire({
//     title: `Are you sure?`,
//     text: `You are about to ${action.toLowerCase()} this ${type}.`,
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonColor: currentStatus === 1 ? "#d33" : "#3085d6",
//     cancelButtonColor: "#6c757d",
//     confirmButtonText: `Yes, ${action}`,
//   });

//   if (!confirm.isConfirmed) return; // Stop if user cancels

//   try {
//     setUpdatingId(id);
//     const res = await axios.post(`https://spillas.com/api/v1/org_user/status/${id}`);

//     if (res.status === 200) {
//       Swal.fire({
//         icon: "success",
//         title: "Status Updated",
//         text: `${type} has been ${action.toLowerCase()}d successfully.`,
//         timer: 1500,
//         showConfirmButton: false,
//       });
//       fetchEntities(type); // Refresh current tab data
//     }
//   } catch (err) {
//     console.error("Error updating status:", err);
//     Swal.fire({
//       icon: "error",
//       title: "Failed",
//       text: `Could not ${action.toLowerCase()} this ${type}.`,
//     });
//   } finally {
//     setUpdatingId(null);
//   }
// };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             placeholder="Search by id/name/state/district"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold transition-all duration-200 ${
//               activeTab === tab
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-600 hover:text-blue-600"
//             }`}
//             onClick={() => {
//               setActiveTab(tab);
//               fetchEntities(tab);
//             }}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <EntityTable
//             title={activeTab}
//             rows={data[activeTab]?.rows || []}
//             type={activeTab}
//             meta={data[activeTab]?.meta}
//             onPageChange={(page) => handlePageChange(activeTab, page)}
//             onToggle={(type, id, currentStatus) => handleToggle(type, id, currentStatus)} // ✅ pass status
//           />
//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//         <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//           <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
//               <button onClick={() => setShowAdd(false)} className="text-gray-500 hover:text-gray-700">
//                 ✕
//               </button>
//             </div>

//             <UserForm onCancel={() => setShowAdd(false)} onSubmit={() => setShowAdd(false)} />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { fetchRoles, getRoleName, ROLE_MAP } from "../Data/ROLES";
// import UserForm from "./UserForm";

// export default function Entities() {
//   const [role, setRole] = useState(""); // role name like "Company"
//   const [userId, setUserId] = useState(null);
//   const [rolesLoaded, setRolesLoaded] = useState(false);
//   const [data, setData] = useState({});
//   const [filter, setFilter] = useState("");
//   const [activeTab, setActiveTab] = useState("");

//   const [showAdd, setShowAdd] = useState(false);

//   // 🔹 Fetch roles dynamically
//   useEffect(() => {
//     async function loadRoles() {
//       await fetchRoles();
//       setRolesLoaded(true);
//     }
//     loadRoles();
//   }, []);

//   // 🔹 Get session data
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const loginRoleId = user?.data[0]?.role;
//         setRole(getRoleName(loginRoleId)); // map role ID to name
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   }, [rolesLoaded]); // wait for roles to load

//   // 🔹 Determine which roles can be created
//   const canCreate = CREATE_CAP[role] || [];

//   // 🔹 Role hierarchy for tabs
//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // 🔹 API mapping for fetching data
//   const apiRoleMap = {
//     Company: {
//       CNF: { role: 3, parentKey: "company_id" },
//       "Super Stockist": { role: 4, parentKey: "company_id" },
//       Distributor: { role: 5, parentKey: "company_id" },
//       "Micro Distributor": { role: 6, parentKey: "company_id" },
//       Retailer: { role: 7, parentKey: "company_id" },
//     },
//     CNF: {
//       "Super Stockist": { role: 4, parentKey: "cnf_id" },
//       Distributor: { role: 5, parentKey: "cnf_id" },
//       "Micro Distributor": { role: 6, parentKey: "cnf_id" },
//       Retailer: { role: 7, parentKey: "cnf_id" },
//     },
//     "Super Stockist": {
//       Distributor: { role: 5, parentKey: "ss_id" },
//       "Micro Distributor": { role: 6, parentKey: "ss_id" },
//       Retailer: { role: 7, parentKey: "ss_id" },
//     },
//     Distributor: { "Micro Distributor": { role: 6, parentKey: "dist_id" }, Retailer: { role: 7, parentKey: "dist_id" } },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // 🔹 Fetch entity data
//   const fetchEntities = async (entityType, page = 1) => {
//     if (!role || !userId) return;
//     const map = apiRoleMap[role]?.[entityType];
//     if (!map) return;

//     try {
//       const res = await axios.get("https://spillas.com/api/v1/org_user", {
//         params: { role: map.role, [map.parentKey]: userId, page, per_page: 10 },
//       });

//       setData((prev) => ({
//         ...prev,
//         [entityType]: {
//           rows: res.data.data || [],
//           meta: { current_page: res.data.current_page, last_page: res.data.last_page },
//         },
//       }));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // 🔹 Initial load for first tab
//   useEffect(() => {
//     if (role) {
//       const firstTab = roleTables[role]?.[0];
//       setActiveTab(firstTab);
//       if (firstTab) fetchEntities(firstTab);
//     }
//   }, [role, userId]);

//   const handlePageChange = (entityType, page) => {
//     fetchEntities(entityType, page);
//   };

  // const remapEntity = (type, id, newParent) => {
  //   setData((d) => {
  //     const upd = (arr) => arr.map((x) => (x.id === id ? { ...x, parent: newParent } : x));
  //     if (type === "Super Stockist") return { ...d, sstks: upd(d.sstks) };
  //     if (type === "Distributor") return { ...d, dists: upd(d.dists) };
  //     if (type === "Micro Distributor") return { ...d, mdists: upd(d.mdists) };
  //     if (type === "Retailer") return { ...d, rets: upd(d.rets) };
  //     return d;
  //   });
  // };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//             placeholder="Search by id/name/state/district"
//             className="rounded-lg border px-2 py-1 text-sm"
//           />

//           {canCreate.length > 0 && (
//             <BlueButton
//               brand={BRAND}
//               onClick={() => setShowAdd(true)}
//               className="inline-flex items-center gap-1 px-3 py-1 sm:px-4 sm:py-2 whitespace-nowrap"
//             >
//               <Plus size={14} />
//               <span className="hidden sm:inline">Register Now</span>
//             </BlueButton>
//           )}
//          {role === "Company" && <RemapButton data={data} onRemap={remapEntity} />}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold ${
//               activeTab === tab ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-600"
//             }`}
//             onClick={() => {
//               setActiveTab(tab);
//               fetchEntities(tab);
//             }}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Active Table */}
//       <div className="mt-3">
//         {activeTab && (
//           <EntityTable
//             title={activeTab}
//             rows={data[activeTab]?.rows || []}
//             type={activeTab}
//             onToggle={(type, id) => {}}
//             meta={data[activeTab]?.meta}
//             onPageChange={(page) => handlePageChange(activeTab, page)}
//           />
//         )}
//       </div>

//       {/* Add User Modal */}
//       {showAdd && (
//   <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-10 sm:pt-20">
//     <div className="w-full max-w-3xl rounded-2xl bg-white p-6 shadow-xl animate-slideDown">
//       <div className="flex items-center justify-between mb-4">
//         <h3 className="text-lg font-semibold text-[#0A3E91]">Add User</h3>
//         <button
//           onClick={() => setShowAdd(false)}
//           className="text-gray-500 hover:text-gray-700"
//         >
//           ✕
//         </button>
//       </div>

//       <UserForm
//         onCancel={() => setShowAdd(false)}
//         onSubmit={() => setShowAdd(false)}
//       />
//     </div>
//   </div>
// )}

//     </div>
//   );
// }


// function match(x, q) {
//   return [x.id, x.org_code, x.business_name, x.dist_name || "", x.state || "", x.district || ""].join(" ").toLowerCase().includes((q || "").toLowerCase());
// }


// import { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import RedButton from "../Components/RedButton";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { ROLE_MAP, getRoleName } from "../Data/ROLES";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [data, setData] = useState({ cnfs: [], sstks: [], dists: [], mdists: [], rets: [] });
//   const [filter, setFilter] = useState("");
//   const [activeTab, setActiveTab] = useState(""); // 🟢 Track active tab

//   const [regOpen, setRegOpen] = useState(false);
//   const [regType, setRegType] = useState("Retailer");
//   const [reg, setReg] = useState({
//     businessName: "",
//     ownerName: "",
//     phone: "",
//     email: "",
//     pincode: "",
//     state: "",
//     district: "",
//     location: "",
//     address: "",
//     parent: "",
//     status: "Active",
//   });

//   // Read role & user id from session
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const numericRole = user?.data[0]?.role;
//         setRole(getRoleName(numericRole));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error("Invalid session data:", err);
//       }
//     }
//   }, []);

//   const canCreate = CREATE_CAP[role] || [];

//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   const apiRoleMap = {
//     Company: { CNF: { role: 3, parentKey: "company_id" }, "Super Stockist": { role: 4, parentKey: "company_id" }, Distributor: { role: 5, parentKey: "company_id" }, "Micro Distributor": { role: 6, parentKey: "company_id" }, Retailer: { role: 7, parentKey: "company_id" } },
//     CNF: { "Super Stockist": { role: 4, parentKey: "cnf_id" }, Distributor: { role: 5, parentKey: "cnf_id" }, "Micro Distributor": { role: 6, parentKey: "cnf_id" }, Retailer: { role: 7, parentKey: "cnf_id" } },
//     "Super Stockist": { Distributor: { role: 5, parentKey: "ss_id" }, "Micro Distributor": { role: 6, parentKey: "ss_id" }, Retailer: { role: 7, parentKey: "ss_id" } },
//     Distributor: { "Micro Distributor": { role: 6, parentKey: "dist_id" }, Retailer: { role: 7, parentKey: "dist_id" } },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // Fetch data from API
//   useEffect(() => {
//     if (!role || !userId) return;

//     const fetchData = async () => {
//       try {
//         const fetchPromises = Object.entries(apiRoleMap[role] || {}).map(async ([entityType, { role: r, parentKey }]) => {
//           const params = { role: r, page: 1, per_page: 10, [parentKey]: userId };
//           const url = `https://spillas.com/api/v1/org_user`;
//           const res = await axios.get(url, { params });
//           return [entityType, res.data.data || []];
//         });

//         const results = await Promise.all(fetchPromises);

//         const newData = { cnfs: [], sstks: [], dists: [], mdists: [], rets: [] };
//         results.forEach(([entityType, list]) => {
//           switch (entityType) {
//             case "CNF": newData.cnfs = list; break;
//             case "Super Stockist": newData.sstks = list; break;
//             case "Distributor": newData.dists = list; break;
//             case "Micro Distributor": newData.mdists = list; break;
//             case "Retailer": newData.rets = list; break;
//             default: break;
//           }
//         });

//         setData(newData);
//         // Set first available tab as active
//         const firstTab = roleTables[role]?.[0] || "";
//         setActiveTab(firstTab);
//       } catch (err) {
//         console.error("Failed to fetch entities:", err);
//       }
//     };

//     fetchData();
//   }, [role, userId]);

//   const addEntity = (type, payload) => {
//     const rand = () => Math.floor(100 + Math.random() * 900);
//     const base = { name: payload.businessName, state: payload.state, district: payload.district, status: payload.status };

//     if (type === "CNF") setData((d) => ({ ...d, cnfs: [{ id: `CNF-${rand()}`, ...base }, ...d.cnfs] }));
//     if (type === "Super Stockist") setData((d) => ({ ...d, sstks: [{ id: `SS-${rand()}`, parent: payload.parent, ...base }, ...d.sstks] }));
//     if (type === "Distributor") setData((d) => ({ ...d, dists: [{ id: `DST-${rand()}`, parent: payload.parent, ...base }, ...d.dists] }));
//     if (type === "Micro Distributor") setData((d) => ({ ...d, mdists: [{ id: `MD-${rand()}`, parent: payload.parent, ...base }, ...d.mdists] }));
//     if (type === "Retailer") setData((d) => ({ ...d, rets: [{ id: `RT-${rand()}`, parent: payload.parent, regular: 0, smart: 0, ...base }, ...d.rets] }));
//   };

//   const toggleStatus = (type, id) => {
//     setData((d) => {
//       const flip = (arr) => arr.map((x) => (x.id === id ? { ...x, status: x.is_active === 1 ? "Active" : "Inactive" } : x));
//       if (type === "CNF") return { ...d, cnfs: flip(d.cnfs) };
//       if (type === "Super Stockist") return { ...d, sstks: flip(d.sstks) };
//       if (type === "Distributor") return { ...d, dists: flip(d.dists) };
//       if (type === "Micro Distributor") return { ...d, mdists: flip(d.mdists) };
//       if (type === "Retailer") return { ...d, rets: flip(d.rets) };
//       return d;
//     });
//   };

//   const lists = useMemo(() => ({
//     CNF: data.cnfs.filter((x) => match(x, filter)),
//     "Super Stockist": data.sstks.filter((x) => match(x, filter)),
//     Distributor: data.dists.filter((x) => match(x, filter)),
//     "Micro Distributor": data.mdists.filter((x) => match(x, filter)),
//     Retailer: data.rets.filter((x) => match(x, filter)),
//   }), [data, filter]);

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search by id/name/state/district" className="rounded-lg border px-2 py-1 text-sm" />
          
//           {canCreate.length > 0 && (
//             <BlueButton brand={BRAND} onClick={() => { setRegOpen(true); setRegType(canCreate[0]); }}>
//               <Plus className="inline mr-1" size={14} />Register New
//             </BlueButton>
//           )}

//           {role === "Company" && <RemapButton data={data} onRemap={(type, id, newParent) => {}} />}
//         </div>
//       </Header>

//       {/* Tabs */}
//       <div className="flex border-b border-gray-200 mt-3">
//         {roleTables[role]?.map((tab) => (
//           <button
//             key={tab}
//             className={`px-4 py-2 font-semibold ${activeTab === tab ? "border-b-2 border-blue-600 text-blue-600" : "text-gray-600"}`}
//             onClick={() => setActiveTab(tab)}
//           >
//             {tab}
//           </button>
//         ))}
//       </div>

//       {/* Render active table */}
//       <div className="mt-3">
//         {activeTab && <EntityTable title={activeTab} rows={lists[activeTab]} type={activeTab} onToggle={toggleStatus} />}
//       </div>
//     </div>
//   );
// }

// function match(x, q) {
//   return [x.id, x.business_name, x.dist_name || "", x.state || "", x.district || ""].join(" ").toLowerCase().includes((q || "").toLowerCase());
// }


// import { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import RedButton from "../Components/RedButton";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { ROLE_MAP, getRoleName } from "../Data/ROLES";

// export default function Entities() {
//   const [role, setRole] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [data, setData] = useState({ cnfs: [], sstks: [], dists: [], mdists: [], rets: [] });
//   const [filter, setFilter] = useState("");

//   const [regOpen, setRegOpen] = useState(false);
//   const [regType, setRegType] = useState("Retailer");
//   const [reg, setReg] = useState({
//     businessName: "",
//     ownerName: "",
//     phone: "",
//     email: "",
//     pincode: "",
//     state: "",
//     district: "",
//     location: "",
//     address: "",
//     parent: "",
//     status: "Active",
//   });

//   // Read role & user id from session
//   useEffect(() => {
//     const stored = sessionStorage.getItem("authUserData1");
//     if (stored) {
//       try {
//         const user = JSON.parse(stored);
//         const numericRole = user?.data[0]?.role;
//         setRole(getRoleName(numericRole));
//         setUserId(user?.data[0]?.id);
//       } catch (err) {
//         console.error("Invalid session data:", err);
//       }
//     }
//   }, []);

//   const canCreate = CREATE_CAP[role] || [];

//   const roleTables = {
//     Company: ["CNF", "Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     CNF: ["Super Stockist", "Distributor", "Micro Distributor", "Retailer"],
//     "Super Stockist": ["Distributor", "Micro Distributor", "Retailer"],
//     Distributor: ["Micro Distributor", "Retailer"],
//     "Micro Distributor": ["Retailer"],
//     Retailer: [],
//   };

//   // Mapping entity type to API role & parent key
//   const apiRoleMap = {
//     Company: { CNF: { role: 3, parentKey: "company_id" }, "Super Stockist": { role: 4, parentKey: "company_id" }, Distributor: { role: 5, parentKey: "company_id" }, "Micro Distributor": { role: 6, parentKey: "company_id" }, Retailer: { role: 7, parentKey: "company_id" } },
//     CNF: { "Super Stockist": { role: 4, parentKey: "cnf_id" }, Distributor: { role: 5, parentKey: "cnf_id" }, "Micro Distributor": { role: 6, parentKey: "cnf_id" }, Retailer: { role: 7, parentKey: "cnf_id" } },
//     "Super Stockist": { Distributor: { role: 5, parentKey: "ss_id" }, "Micro Distributor": { role: 6, parentKey: "ss_id" }, Retailer: { role: 7, parentKey: "ss_id" } },
//     Distributor: { "Micro Distributor": { role: 6, parentKey: "dist_id" }, Retailer: { role: 7, parentKey: "dist_id" } },
//     "Micro Distributor": { Retailer: { role: 7, parentKey: "dist_id" } },
//   };

//   // Fetch data from API
//   useEffect(() => {
//     if (!role || !userId) return;

//     const fetchData = async () => {
//       try {
//         const entityTypes = Object.keys(roleTables[role] || {});
//         const fetchPromises = Object.entries(apiRoleMap[role] || {}).map(async ([entityType, { role: r, parentKey }]) => {
//           const params = { role: r, page: 1, per_page: 100, [parentKey]: userId };
//           const url = `https://spillas.com/api/v1/org_user`;
//           const res = await axios.get(url, { params });
//           return [entityType, res.data.data || []];
//         });

//         const results = await Promise.all(fetchPromises);

//         const newData = { cnfs: [], sstks: [], dists: [], mdists: [], rets: [] };
//         results.forEach(([entityType, list]) => {
//           switch (entityType) {
//             case "CNF": newData.cnfs = list; break;
//             case "Super Stockist": newData.sstks = list; break;
//             case "Distributor": newData.dists = list; break;
//             case "Micro Distributor": newData.mdists = list; break;
//             case "Retailer": newData.rets = list; break;
//             default: break;
//           }
//         });

//         setData(newData);
//       } catch (err) {
//         console.error("Failed to fetch entities:", err);
//       }
//     };

//     fetchData();
//   }, [role, userId]);

//   // Add, toggle, remap functions remain the same
//   const addEntity = (type, payload) => {
//     const rand = () => Math.floor(100 + Math.random() * 900);
//     const base = { name: payload.businessName, state: payload.state, district: payload.district, status: payload.status };

//     if (type === "CNF") setData((d) => ({ ...d, cnfs: [{ id: `CNF-${rand()}`, ...base }, ...d.cnfs] }));
//     if (type === "Super Stockist") setData((d) => ({ ...d, sstks: [{ id: `SS-${rand()}`, parent: payload.parent, ...base }, ...d.sstks] }));
//     if (type === "Distributor") setData((d) => ({ ...d, dists: [{ id: `DST-${rand()}`, parent: payload.parent, ...base }, ...d.dists] }));
//     if (type === "Micro Distributor") setData((d) => ({ ...d, mdists: [{ id: `MD-${rand()}`, parent: payload.parent, ...base }, ...d.mdists] }));
//     if (type === "Retailer") setData((d) => ({ ...d, rets: [{ id: `RT-${rand()}`, parent: payload.parent, regular: 0, smart: 0, ...base }, ...d.rets] }));
//   };

//   const toggleStatus = (type, id) => {
//     setData((d) => {
//       const flip = (arr) => arr.map((x) => (x.id === id ? { ...x, status: x.status === "Active" ? "Inactive" : "Active" } : x));
//       if (type === "CNF") return { ...d, cnfs: flip(d.cnfs) };
//       if (type === "Super Stockist") return { ...d, sstks: flip(d.sstks) };
//       if (type === "Distributor") return { ...d, dists: flip(d.dists) };
//       if (type === "Micro Distributor") return { ...d, mdists: flip(d.mdists) };
//       if (type === "Retailer") return { ...d, rets: flip(d.rets) };
//       return d;
//     });
//   };

//   const remapEntity = (type, id, newParent) => {
//     setData((d) => {
//       const upd = (arr) => arr.map((x) => (x.id === id ? { ...x, parent: newParent } : x));
//       if (type === "Super Stockist") return { ...d, sstks: upd(d.sstks) };
//       if (type === "Distributor") return { ...d, dists: upd(d.dists) };
//       if (type === "Micro Distributor") return { ...d, mdists: upd(d.mdists) };
//       if (type === "Retailer") return { ...d, rets: upd(d.rets) };
//       return d;
//     });
//   };

//   const lists = useMemo(() => ({
//     cnf: data.cnfs.filter((x) => match(x, filter)),
//     ss: data.sstks.filter((x) => match(x, filter)),
//     dist: data.dists.filter((x) => match(x, filter)),
//     md: data.mdists.filter((x) => match(x, filter)),
//     ret: data.rets.filter((x) => match(x, filter)),
//   }), [data, filter]);

//   const parentOptions = {
//     "Super Stockist": data.cnfs,
//     "Distributor": data.sstks,
//     "Micro Distributor": [...data.dists, ...data.mdists],
//     "Retailer": [...data.dists, ...data.mdists],
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search by id/name/state/district" className="rounded-lg border px-2 py-1 text-sm" />
          
//           {/* Register New button only for allowed roles */}
//           {canCreate.length > 0 && (
//             <BlueButton brand={BRAND} onClick={() => { setRegOpen(true); setRegType(canCreate[0]); }}>
//               <Plus className="inline mr-1" size={14} />Register New
//             </BlueButton>
//           )}

//           {/* Remap only visible to Company */}
//           {role === "Company" && <RemapButton data={data} onRemap={remapEntity} />}
//         </div>
//       </Header>

//       {/* Render tables based on role */}
//       {roleTables[role]?.includes("CNF") && <EntityTable title="CNFs" rows={lists.cnf} type="CNF" onToggle={toggleStatus} />}
//       {roleTables[role]?.includes("Super Stockist") && <EntityTable title="Super Stockists" rows={lists.ss} type="Super Stockist" onToggle={toggleStatus} />}
//       {roleTables[role]?.includes("Distributor") && <EntityTable title="Distributors" rows={lists.dist} type="Distributor" onToggle={toggleStatus} />}
//       {roleTables[role]?.includes("Micro Distributor") && <EntityTable title="Micro Distributors" rows={lists.md} type="Micro Distributor" onToggle={toggleStatus} />}
//       {roleTables[role]?.includes("Retailer") && <EntityTable title="Retailers" rows={lists.ret} type="Retailer" onToggle={toggleStatus} />}

//       <Card brand={BRAND} title="Sample Hierarchy Reports (with State & District)">
//         <SimpleTable headers={["Retailer ID", "Retailer Name", "Reports To", "Regular Keys", "State", "District"]} rows={[["RTL123", "XYZ Retailer", "ABCD Distributor", 150, "Maharashtra", "Pune"]]} />
//         <div className="mt-3" />
//         <SimpleTable headers={["Distributor ID", "Distributor Name", "Reports To", "Regular Keys", "State", "District"]} rows={[["DIST123", "ABDC Distributor", "XYZ Super Stockist", 200, "Maharashtra", "Pune"]]} />
//       </Card>

//       {/* Register Modal */}
//       {regOpen && (
//         <div className="rounded-2xl border bg-white p-4 shadow-xl">
//           <h3 className="text-sm font-semibold" style={{ color: BRAND.darkBlue }}>Register New {regType}</h3>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-2">
//             <select value={regType} onChange={(e) => setRegType(e.target.value)} className="rounded-lg border px-2 py-2 text-sm">
//               {canCreate.map((t) => (<option key={t}>{t}</option>))}
//             </select>

//             {parentOptions[regType] && (
//               <select value={reg.parent} onChange={(e) => setReg({ ...reg, parent: e.target.value })} className="rounded-lg border px-2 py-2 text-sm">
//                 <option value="">Select Parent</option>
//                 {parentOptions[regType].map((p) => (<option key={p.id} value={p.id}>{p.name} ({p.id})</option>))}
//               </select>
//             )}

//             <select value={reg.status} onChange={(e) => setReg({ ...reg, status: e.target.value })} className="rounded-lg border px-2 py-2 text-sm">
//               <option>Active</option>
//               <option>Inactive</option>
//             </select>

//             <input value={reg.businessName} onChange={(e) => setReg({ ...reg, businessName: e.target.value })} placeholder="Business Name" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.ownerName} onChange={(e) => setReg({ ...reg, ownerName: e.target.value })} placeholder="Owner Name" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.phone} onChange={(e) => setReg({ ...reg, phone: e.target.value })} placeholder="Phone No" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.email} onChange={(e) => setReg({ ...reg, email: e.target.value })} placeholder="Email ID" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.pincode} onChange={(e) => setReg({ ...reg, pincode: e.target.value })} placeholder="Pincode" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.state} onChange={(e) => setReg({ ...reg, state: e.target.value })} placeholder="State" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.district} onChange={(e) => setReg({ ...reg, district: e.target.value })} placeholder="District" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.location} onChange={(e) => setReg({ ...reg, location: e.target.value })} placeholder="Location" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.address} onChange={(e) => setReg({ ...reg, address: e.target.value })} placeholder="Address" className="lg:col-span-2 rounded-lg border px-3 py-2 text-sm" />

//             <div className="lg:col-span-3 flex justify-end gap-2 mt-1">
//               <RedButton brand={BRAND} onClick={() => setRegOpen(false)}>Cancel</RedButton>
//               <BlueButton brand={BRAND} onClick={() => { addEntity(regType, reg); setRegOpen(false); }}>Save</BlueButton>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function match(x, q) {
//   return [x.id, x.name, x.parent || "", x.state || "", x.district || ""].join(" ").toLowerCase().includes((q || "").toLowerCase());
// }


// **************************************20-10-2025 PHASE 1************************************


// import { useState, useMemo } from "react";
// import Header from "../Components/Header";
// import BlueButton from "../Components/BlueButton";
// import { BRAND } from "../css/brand";
// import RemapButton from "../Components/RemapButton";
// import EntityTable from "../Components/EntityTable";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import RedButton from "../Components/RedButton";
// import { Plus } from "lucide-react";
// import { CREATE_CAP } from "../Data/CREATE_CAP";
// import { seed } from "../Data/seed";


// export default function Entities({ role }) {
//   const [data, setData] = useState(seed);
//   const [filter, setFilter] = useState("");
//   const canCreate = CREATE_CAP[role] || [];

//   const [regOpen, setRegOpen] = useState(false);
//   const [regType, setRegType] = useState(canCreate[0] || "Retailer");
//   const [reg, setReg] = useState({ businessName: "", ownerName: "", phone: "", email: "", pincode: "", state: "", district: "", location: "", address: "", parent: "", status: "Active" });

//   const addEntity = (type, payload) => {
//     const rand = () => Math.floor(100 + Math.random() * 900);
//     const base = { name: payload.businessName, state: payload.state, district: payload.district, status: payload.status };
//     if (type === "CNF") setData((d) => ({ ...d, cnfs: [{ id: `CNF-${rand()}`, ...base }, ...d.cnfs] }));
//     if (type === "Super Stockist") setData((d) => ({ ...d, sstks: [{ id: `SS-${rand()}`, parent: payload.parent, ...base }, ...d.sstks] }));
//     if (type === "Distributor") setData((d) => ({ ...d, dists: [{ id: `DST-${rand()}`, parent: payload.parent, ...base }, ...d.dists] }));
//     if (type === "Micro Distributor") setData((d) => ({ ...d, mdists: [{ id: `MD-${rand()}`, parent: payload.parent, ...base }, ...d.mdists] }));
//     if (type === "Retailer") setData((d) => ({ ...d, rets: [{ id: `RT-${rand()}`, parent: payload.parent, regular: 0, smart: 0, ...base }, ...d.rets] }));
//   };

//   const toggleStatus = (type, id) => {
//     setData((d) => {
//       const flip = (arr) => arr.map((x) => (x.id === id ? { ...x, status: x.status === "Active" ? "Inactive" : "Active" } : x));
//       if (type === "CNF") return { ...d, cnfs: flip(d.cnfs) };
//       if (type === "Super Stockist") return { ...d, sstks: flip(d.sstks) };
//       if (type === "Distributor") return { ...d, dists: flip(d.dists) };
//       if (type === "Micro Distributor") return { ...d, mdists: flip(d.mdists) };
//       if (type === "Retailer") return { ...d, rets: flip(d.rets) };
//       return d;
//     });
//   };

//   const remapEntity = (type, id, newParent) => {
//     setData((d) => {
//       const upd = (arr) => arr.map((x) => (x.id === id ? { ...x, parent: newParent } : x));
//       if (type === "Super Stockist") return { ...d, sstks: upd(d.sstks) };
//       if (type === "Distributor") return { ...d, dists: upd(d.dists) };
//       if (type === "Micro Distributor") return { ...d, mdists: upd(d.mdists) };
//       if (type === "Retailer") return { ...d, rets: upd(d.rets) };
//       return d;
//     });
//   };

//   const lists = useMemo(() => ({
//     cnf: data.cnfs.filter((x) => match(x, filter)),
//     ss: data.sstks.filter((x) => match(x, filter)),
//     dist: data.dists.filter((x) => match(x, filter)),
//     md: data.mdists.filter((x) => match(x, filter)),
//     ret: data.rets.filter((x) => match(x, filter)),
//   }), [data, filter]);

//   const parentOptions = {
//     "Super Stockist": data.cnfs,
//     "Distributor": data.sstks,
//     "Micro Distributor": [...data.dists, ...data.mdists],
//     "Retailer": [...data.dists, ...data.mdists],
//   };

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header brand={BRAND} title="Manage Network">
//         <div className="flex flex-wrap items-center gap-2">
//           <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search by id/name/state/district" className="rounded-lg border px-2 py-1 text-sm" />
//           {(CREATE_CAP[role] || []).length > 0 && (
//             <BlueButton brand={BRAND} onClick={() => { setRegOpen(true); setRegType(CREATE_CAP[role][0]); }}>
//               <Plus className="inline mr-1" size={14} />Register New
//             </BlueButton>
//           )}
//           {role === "Company" && <RemapButton data={data} onRemap={remapEntity} />}
//         </div>
//       </Header>

//       <EntityTable title="CNFs" rows={lists.cnf} type="CNF" onToggle={toggleStatus} />
//       <EntityTable title="Super Stockists" rows={lists.ss} type="Super Stockist" onToggle={toggleStatus} />
//       <EntityTable title="Distributors" rows={lists.dist} type="Distributor" onToggle={toggleStatus} />
//       <EntityTable title="Micro Distributors" rows={lists.md} type="Micro Distributor" onToggle={toggleStatus} />
//       <EntityTable title="Retailers" rows={lists.ret} type="Retailer" onToggle={toggleStatus} />

//       <Card brand={BRAND} title="Sample Hierarchy Reports (with State & District)">
//         <SimpleTable headers={["Retailer ID", "Retailer Name", "Reports To", "Regular Keys", "State", "District"]} rows={[["RTL123", "XYZ Retailer", "ABCD Distributor", 150, "Maharashtra", "Pune"]]} />
//         <div className="mt-3" />
//         <SimpleTable headers={["Distributor ID", "Distributor Name", "Reports To", "Regular Keys", "State", "District"]} rows={[["DIST123", "ABDC Distributor", "XYZ Super Stockist", 200, "Maharashtra", "Pune"]]} />
//       </Card>

//       {regOpen && (
//         <div className="rounded-2xl border bg-white p-4 shadow-xl">
//           <h3 className="text-sm font-semibold" style={{ color: BRAND.darkBlue }}>Register New {regType}</h3>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-2">
//             <select value={regType} onChange={(e)=>setRegType(e.target.value)} className="rounded-lg border px-2 py-2 text-sm">
//               {(CREATE_CAP[role]||[]).map((t)=>(<option key={t}>{t}</option>))}
//             </select>
//             {parentOptions[regType] && (
//               <select value={reg.parent} onChange={(e)=>setReg({...reg, parent: e.target.value})} className="rounded-lg border px-2 py-2 text-sm">
//                 <option value="">Select Parent</option>
//                 {parentOptions[regType].map((p)=>(<option key={p.id} value={p.id}>{p.name} ({p.id})</option>))}
//               </select>
//             )}
//             <select value={reg.status} onChange={(e)=>setReg({...reg, status: e.target.value})} className="rounded-lg border px-2 py-2 text-sm">
//               <option>Active</option>
//               <option>Inactive</option>
//             </select>
//             <input value={reg.businessName} onChange={(e)=>setReg({...reg, businessName: e.target.value})} placeholder="Business Name" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.ownerName} onChange={(e)=>setReg({...reg, ownerName: e.target.value})} placeholder="Owner Name" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.phone} onChange={(e)=>setReg({...reg, phone: e.target.value})} placeholder="Phone No" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.email} onChange={(e)=>setReg({...reg, email: e.target.value})} placeholder="Email ID" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.pincode} onChange={(e)=>setReg({...reg, pincode: e.target.value})} placeholder="Pincode" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.state} onChange={(e)=>setReg({...reg, state: e.target.value})} placeholder="State" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.district} onChange={(e)=>setReg({...reg, district: e.target.value})} placeholder="District" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.location} onChange={(e)=>setReg({...reg, location: e.target.value})} placeholder="Location" className="rounded-lg border px-3 py-2 text-sm" />
//             <input value={reg.address} onChange={(e)=>setReg({...reg, address: e.target.value})} placeholder="Address" className="lg:col-span-2 rounded-lg border px-3 py-2 text-sm" />
//             <div className="lg:col-span-3 flex justify-end gap-2 mt-1">
//               <RedButton  brand={BRAND} onClick={()=>setRegOpen(false)}>Cancel</RedButton>
//               <BlueButton brand={BRAND} onClick={()=>{ addEntity(regType, reg); setRegOpen(false); }}>Save</BlueButton>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function match(x, q) {
//   return [x.id, x.name, x.parent || "", x.state || "", x.district || ""].join(" ").toLowerCase().includes((q||"").toLowerCase());
// }